import {
  CONFIRMED_CREATE_CATEGORY_ACTION,
  CONFIRMED_DELETE_CATEGORY_ACTION,
  CONFIRMED_EDIT_CATEGORY_ACTION,
  CONFIRMED_GET_CATEGORIES,
} from "../actions/CategoryType";

const initialState = {
  categories: [],
  loading: false,
  error: null,
  num_rows: 0,
};

export default function CategoriesReducer(state = initialState, action) {
  switch (action.type) {
    case CONFIRMED_GET_CATEGORIES:
      return {
        ...state,
        // categories: action.payload,
        categories: action.payload.categories,
        num_rows: action.payload.num_rows,
        loading: false,
        error: null,
      };

    case CONFIRMED_DELETE_CATEGORY_ACTION:
      return {
        ...state,
        categories: state.categories.filter(
          (category) => category.category_id !== action.payload.category_id
        ),
      };

    case CONFIRMED_EDIT_CATEGORY_ACTION:
      return {
        ...state,
        categories: state.categories.map((cat) =>
          cat.category_id === action.payload.category_id ? action.payload : cat
        ),
      };

    case CONFIRMED_CREATE_CATEGORY_ACTION:
      return {
        ...state,
        categories: [...state.categories, action.payload],
      };

    default:
      return state;
  }
}
